import { Directive, DirectiveBinding } from 'vue'
import DOMPurify from 'dompurify'

function sanitizeHtml(html: string): string {
  const sanitizeOptions: DOMPurify.Config = {
    ALLOWED_TAGS: ['b', 'br', 'a', 'i', 'ul', 'li']
  }

  return DOMPurify.sanitize(html, sanitizeOptions).toString()
}

function sanitize(el: HTMLElement, value: string) {
  el.innerHTML = sanitizeHtml(value)
}

const sanitizeHtmlDirective: Directive = {
  mounted: (el: HTMLElement, binding: DirectiveBinding) => {
    sanitize(el, binding.value)
  },
  updated: (el: HTMLElement, binding: DirectiveBinding) => {
    sanitize(el, binding.value)
  }
}

export default sanitizeHtmlDirective
